// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".entity-data-row[data-v-06f3c27e]{border-bottom:1px solid #ededed;list-style:none;padding:1rem 0}.entity-data-row[data-v-06f3c27e]:last-child{border-bottom:none}.entity-data-row .semibold[data-v-06f3c27e]{font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
